<div class="ws-slide-toggle"
     [class.disabled]="disabled"
     [dwsPermission]="permission"
     dwsPermissionDenyMode="disable">
  <div class="left-content" #leftContent (click)="toggleFromLeft($event)" [class.disabled]="disabled">
    <ng-content select="[left]"></ng-content>
  </div>

  <input
    type="checkbox"
    class="apple-switch"
    #slideToggle
    (change)="clickHandler($event)"
    [checked]="checked"
    [disabled]="disabled"
  >

  <div class="right-content" #rightContent (click)="toggleFromRight($event)" [class.disabled]="disabled">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
